import { render, staticRenderFns } from "./CASEBlobItem.vue?vue&type=template&id=107c7d58"
import script from "./CASEBlobItem.vue?vue&type=script&lang=js"
export * from "./CASEBlobItem.vue?vue&type=script&lang=js"
import style0 from "./CASEBlobItem.vue?vue&type=style&index=0&id=107c7d58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports